export const SET_ORDERS_COUNTER_ORDERS = 'SET_ORDERS_COUNTER_ORDERS'
export const APPEND_ORDERS_COUNTER_ORDER = 'APPEND_ORDERS_COUNTER_ORDER'
export  const REMOVE_ORDERS_COUNTER_ORDER = 'REMOVE_ORDERS_COUNTER_ORDER'
export const SET_UNPAID_ORDERS_COUNTER_ORDERS = 'SET_UNPAID_ORDERS_COUNTER_ORDERS'
export const APPEND_UNPAID_ORDERS_COUNTER_ORDER = 'APPEND_UNPAID_ORDERS_COUNTER_ORDER'
export  const REMOVE_UNPAID_ORDERS_COUNTER_ORDER = 'REMOVE_UNPAID_ORDERS_COUNTER_ORDER'
export const SET_PRE_ORDERS_COUNTER = 'SET_PRE_ORDERS_COUNTER'
